<script setup>
import { Inertia } from '@inertiajs/inertia'
import JetInput from '@/Jetstream/Input.vue'
import JetTextarea from '@/Jetstream/Textarea.vue'
import JetLabel from '@/Jetstream/Label.vue'
import { useForm, usePage } from '@inertiajs/inertia-vue3';
import { onMounted, computed, ref } from 'vue'

const honeypot = computed(() => usePage().props.value.honeypot)

const form = useForm({
    first_name: '',
    last_name: '',
    email: '',
    company: '',
    phone: '',
    message: '',
    property_id: null,
    [honeypot.nameFieldName]: '',
    [honeypot.validFromFieldName]: honeypot.encryptedValidFrom,
    reference: 'Header Enquiry Button'
});

const submit = () => {
    form.post(route('contact.store'), {
        onSuccess: () => form.reset('first_name', 'last_name', 'email', 'company', 'phone', 'message'),
    });
}

document.addEventListener('hide.bs.modal', () => {
    form.property_id = null;
    form.message = '';
});

const property = ref(0);
const property_title = ref('');
const property_location = ref('');
const image = ref('');
const reference = ref('');

onMounted(() => {
    emitter.on('propertyModal', property => {
        property.value = property.property_id;
        axios.get('/api/property/' + property.value).then(response => {
            let property = response.data;
            form.property_id = property.id;
            form.message = `Hi, I found a property listing "${property.reference }" on your website ${ app_name } and would like to know more about it.`;
            let languages = property.languages;
            let images = (property.images != null) ? JSON.parse(property.images) : [];
            let location = property.location != null ? JSON.parse(JSON.stringify(property.location)) : null;
            reference.value = property.reference;

            if(images && images.length > 0){
                let propertyImage = JSON.parse(JSON.stringify(images[0]));
                if(propertyImage){
                    propertyImage = (propertyImage.medium) ? propertyImage.medium : (propertyImage.thumb ? propertyImage.thumb : null);
                    if(propertyImage){
                        image.value = propertyImage.link;
                    }
                }
            }

            if(languages){
                languages = JSON.parse(languages);
                if(languages){
                    property_title.value = languages[0].title;
                }
            }

            if(location){
                property_location.value = ((location.tower != null ? location.tower + ', ' : '') + (location.sub_community != null ? location.sub_community + ', ' : '') + (location.community != null ? location.community + ', ' : '') + (location.city != null ? location.city : ''))
            }

            form.reference = 'Property Modal';

        }).catch(error => {
            //
        });
    })

    document.addEventListener('hide.bs.modal', () => {
        property.value = 0;
        property_title.value = '';
        property_location.value = '';
        image.value = '';
        reference.value = '';
    });
});

</script>

<template>
    <!-- Modal -->
    <div class="modal fade" id="enquiryModal" tabindex="-1" aria-labelledby="enquiryModalLabel" aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered modal-lg">
            <div class="modal-content">
                <form action="" method="post" @submit.prevent="submit">
                    <div v-if="honeypot.enabled" :name="`${honeypot.nameFieldName}_wrap`" style="display:none;">
                        <input type="text" v-model="form[honeypot.nameFieldName]" :name="honeypot.nameFieldName" :id="honeypot.nameFieldName" />
                        <input type="text" v-model="form[honeypot.validFromFieldName]" :name="honeypot.validFromFieldName" />
                    </div>
                    <div class="row w-100">
                        <progress v-if="form.progress" :value="form.progress.percentage" max="100">
                            {{ form.progress.percentage }}%
                        </progress>
                    </div>
                    <div class="modal-header border-0 pb-0">
                        <div class="d-flex w-100 justify-content-between">
                            <div class="heading">
                                <h1>Submit An Enquiry.</h1>
                                <p>Submit your details and we'll get in touch with you.</p>
                            </div>
                            <button type="button" class="btn-close btn-sm" data-bs-dismiss="modal" aria-label="Close"></button>
                        </div>
                    </div>
                    <div class="modal-body">
                        <div class="row property mb-2" v-if="property_title != ''">
                            <div class="col-4">
                                <img :src="image" :alt="property_title" class="img-fluid p-1 border rounded-0 with-loading" onerror="this.src='/images/image-not-found.jpg'">
                            </div>
                            <div class="col-8">
                                <h3>{{ property_title }}</h3>
                                <p class="mb-1 d-flex align-items-center" v-if="property_location">
                                    <span><svg stroke="currentColor" fill="currentColor" stroke-width="0" viewBox="0 0 512 512" height="1em" width="1em" xmlns="http://www.w3.org/2000/svg"><path fill="none" stroke-linecap="round" stroke-linejoin="round" stroke-width="32" d="M256 48c-79.5 0-144 61.39-144 137 0 87 96 224.87 131.25 272.49a15.77 15.77 0 0025.5 0C304 409.89 400 272.07 400 185c0-75.61-64.5-137-144-137z"></path><circle cx="256" cy="192" r="48" fill="none" stroke-linecap="round" stroke-linejoin="round" stroke-width="32"></circle></svg></span>
                                    {{ property_location }}
                                </p>
                                <p>{{ reference }}</p>
                            </div>
                        </div>
                        <div class="row">
                            <div class="mb-3 col-12 col-lg-6">
                                <JetLabel class="w-100">
                                    Your First Name <span class="text-danger">*</span>
                                    <JetInput v-model="form.first_name" name="first_name" required minlength="2" maxlength="255" type="text" class="d-block mt-1 w-100" placeholder="eg. Norman" />
                                </JetLabel>
                                <p class="d-block text-danger" v-if="form.errors.first_name">{{ form.errors.first_name }}</p>
                            </div>
                            <div class="mb-3 col-12 col-lg-6">
                                <JetLabel class="w-100">
                                    Your Last Name <span class="text-danger">*</span>
                                    <JetInput v-model="form.last_name" name="last_name" required minlength="2" maxlength="255" type="text" class="d-block mt-1 w-100" placeholder="eg. Gwen" />
                                </JetLabel>
                                <p class="d-block text-danger" v-if="form.errors.last_name">{{ form.errors.last_name }}</p>
                            </div>
                            <div class="mb-3 col-12 col-lg-6">
                                <JetLabel class="w-100">
                                    Your Email <span class="text-danger">*</span>
                                    <JetInput v-model="form.email" name="email" required minlength="2" maxlength="255" type="email" class="d-block mt-1 w-100" placeholder="eg. norman.gwen@gmail.com" />
                                </JetLabel>
                                <p class="d-block text-danger" v-if="form.errors.email">{{ form.errors.email }}</p>
                            </div>
                            <!-- <div class="mb-3 col-12 col-lg-6">
                                <JetLabel class="w-100">
                                    Your Company Name
                                    <JetInput minlength="2" name="company" v-model="form.company" maxlength="255" type="text" class="d-block mt-1 w-100" placeholder="eg. Hwellet & Shawn LLC" />
                                </JetLabel>
                                <p class="d-block text-danger" v-if="form.errors.company">{{ form.errors.company }}</p>
                            </div> -->
                            <div class="mb-3 col-12 col-lg-6">
                                <JetLabel class="w-100">
                                    Your Phone
                                    <JetInput minlength="10" name="phone" v-model="form.phone" maxlength="20" type="tel" class="d-block mt-1 w-100" placeholder="eg. (+119) 7768 7876" />
                                </JetLabel>
                                <p class="d-block text-danger" v-if="form.errors.phone">{{ form.errors.phone }}</p>
                            </div>
                            <div class="mb-3 col-12">
                                <JetLabel class="w-100">
                                    Your Message <span class="text-danger">*</span>
                                    <JetTextarea rows="3" required name="message" v-model="form.message" minlength="2" maxlength="1000" class="d-block mt-1 w-100" placeholder="eg. Hi, I found your property. Please contact me. Thank you." />
                                </JetLabel>
                                <p class="d-block text-danger" v-if="form.errors.message">{{ form.errors.message }}</p>
                            </div>
                            <div class="mb-3 col-12">
                                <div class="input-wrap form-check">
                                    <input type="checkbox" class="form-check-input tos" id="exampleCheck1" required name="terms">
                                    <label class="form-check-label" for="exampleCheck1">I agree to the <a :href="route('terms.show')" target="_blank" rel="noopener noreferrer" class="text-dark text-decoration-underline">Terms of Service</a> and
                                    <a :href="route('policy.show')" target="_blank" rel="noopener noreferrer" class="text-dark text-decoration-underline">Privacy Policy</a>.</label>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="modal-footer border-0 mb-3">
                        <div class="d-block alert px-0" v-if="$page.props.flash.success">
                            <p class="text-success">{{ $page.props.flash.success }}</p>
                        </div>
                         <div class="d-block alert px-0" v-if="$page.props.flash.error">
                            <p class="text-danger">{{ $page.props.flash.error }}</p>
                        </div>
                        <button type="submit" class="btn modal-btn" :class="{ 'disabled': form.processing }" :disabled="form.processing">
                            Submit
                            <span><svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 143 158" xml:space="preserve"><g id="_x23_ffffffff"></g><g id="_x23_1e1e1eff"><path class="st0" d="M13.5,10c39.9,23.1,79.9,46.1,119.8,69.2c-39.9,23-79.8,46.1-119.8,69.1C13.5,102.2,13.5,56.1,13.5,10z"></path></g></svg></span>
                        </button>
                    </div>
                </form>
            </div>
        </div>
    </div>
</template>
